import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Combine class names with conflict-resolution against Tailwind. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
